import { CustomPointOfService, RelayPoint, RepairPointOfService } from '../models';

export function computeDistanceKm(
  from: { lat: number; lng: number },
  to: { lat: number; lng: number }
): number | undefined {
  return typeof google !== 'undefined'
    ? google.maps.geometry.spherical.computeDistanceBetween(
      new google.maps.LatLng(from.lat, from.lng),
      new google.maps.LatLng(to.lat, to.lng)
    ) / 1000
    : undefined;
}

export function formatDistanceKm(pointOfService: CustomPointOfService | RepairPointOfService | RelayPoint): string {
  const distance = pointOfService.distanceKm || pointOfService['distanceKM'];
  return distance ? `${distance.toFixed(1)} km` : undefined;
}
